import { Box, Text } from '@mantine/core';
import { Button } from '@vrplatform/components';
import { useAuditEffectsModal } from '../hooks/useAuditEffectsModal';
import { showNotification, updateNotification } from '@vrplatform/theme';

const autoClose = 5000;

export const AUDIT_ACTION_HEADER_NAME = 'x-vrplatform-audit-action-id';

export const showAuditActionNotification = ({
  response,
  id,
}: {
  response: Response;
  id?: string;
}) => {
  const title = 'VRP Admins only';

  const actionId = response.headers.get(AUDIT_ACTION_HEADER_NAME);

  if (!actionId) {
    return;
  }

  if (id) {
    updateNotification({
      id,
      title,
      autoClose,
      message: <SuccessNotificationMessage actionId={actionId} />,
      color: 'gray',
    });
  } else {
    showNotification({
      title,
      autoClose,
      message: <SuccessNotificationMessage actionId={actionId} />,
      color: 'gray',
    });
  }
};

const SuccessNotificationMessage = ({ actionId }: { actionId: string }) => {
  'use memo';
  const { open: openAuditEffectsModal } = useAuditEffectsModal();

  const message = 'Effects are processing in the background.';

  return (
    <Box>
      <Text mb="xs">{message}</Text>
      <Button size="xs" onClick={() => openAuditEffectsModal({ actionId })}>
        View GL Effects
      </Button>
    </Box>
  );
};
